module.exports = __webpack_public_path__ + "img/sbg01.fec03aaf.png";